var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdLogoLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 32,
    viewBox: "0 0 61 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.7927 14.7413C43.821 15.7543 44.8494 16.7673 44.8494 16.7673C46.2346 15.4028 46.2416 14.0452 44.8704 12.6945C43.8421 11.6815 43.1565 11.0061 43.16 10.3274C41.4285 12.033 41.4215 13.3906 42.7927 14.7413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M43.0935 23.2244C43.097 22.5456 43.7896 21.8633 44.8285 20.8399C46.2136 19.4754 46.2207 18.1178 44.8495 16.7672C44.8495 16.7672 43.8106 17.7905 42.7718 18.8139C41.3866 20.1784 41.3796 21.536 43.0935 23.2244Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6187 2.89844C34.9296 2.90189 34.244 2.22655 33.2156 1.21354C31.8445 -0.137138 30.4663 -0.130226 29.0812 1.23428C29.0812 1.23428 30.1095 2.24729 31.1379 3.2603C32.509 4.61098 33.8872 4.60407 35.6187 2.89844Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M27.0038 3.28113C28.0427 2.25775 29.0815 1.23438 29.0815 1.23438C27.7104 -0.116305 26.3322 -0.109393 24.9471 1.25511C23.9082 2.27849 23.2156 2.96074 22.5265 2.9642C24.2404 4.65255 25.6186 4.64564 27.0038 3.28113Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M43.1599 10.3273C44.8914 8.62171 44.8984 7.26411 42.8417 5.23809L40.785 3.21207C38.7283 1.18605 37.3501 1.19296 35.6186 2.89859C36.3077 2.89514 37.3511 3.89336 38.7072 5.25883L40.7639 7.28485C42.1204 8.64993 43.1634 9.64854 43.1599 10.3273Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5264 2.96436C20.8124 1.27601 19.4343 1.28292 17.3565 3.32967L15.2787 5.37643C13.201 7.42319 13.194 8.78078 14.9079 10.4691C14.9114 9.79034 15.9354 8.75232 17.3355 7.40245L19.4132 5.3557C20.8129 4.00545 21.8373 2.96781 22.5264 2.96436Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4752 30.729C37.1891 32.4173 38.5673 32.4104 40.645 30.3637L42.7228 28.3169C44.8006 26.2701 44.8076 24.9126 43.0937 23.2242C43.0902 23.903 42.0661 24.941 40.6661 26.2909L38.5883 28.3376C37.1887 29.6879 36.1643 30.7255 35.4752 30.729Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.67627 12.582H10.0328V15.5163H4.4958V17.1345H8.48195V19.8159H4.4958V24.3684H0.67627V12.582Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.016 19.8838L10.3096 12.582H14.388L16.9361 16.6451L19.6482 12.582H23.7087L18.8356 19.8838V24.3684H15.016V19.8838Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4715 18.4506L23.8573 12.582H28.2305L30.6479 15.6686L33.0831 12.582H37.4563L32.8422 18.4506L37.4922 24.3684H33.119L30.6453 21.2327L28.1716 24.3684H23.7983L28.4689 18.4506H28.4715Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3208 12.269H52.9351C54.3133 12.269 55.5157 12.5152 56.5425 13.0051C57.5693 13.4974 58.366 14.2018 58.9301 15.1206C59.4942 16.0395 59.7762 17.1119 59.7762 18.3402C59.7762 20.3753 59.1651 21.9181 57.9404 22.9637C56.7182 24.0117 55.0357 24.5333 52.898 24.5333H48.3208V12.2666V12.269ZM53.1652 21.4818C54.0807 21.4818 54.7833 21.2016 55.2757 20.6386C55.7681 20.078 56.0155 19.3103 56.0155 18.3402C56.0155 17.475 55.7656 16.756 55.2683 16.1808C54.771 15.6056 54.0856 15.3205 53.2197 15.3205H52.0073V21.4794H53.1652V21.4818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdLogoLoader);
export default __webpack_public_path__ + "static/media/fyxd-logo-loader.ca346a0d451cbdd70fb837e624caec17.svg";
export { ForwardRef as ReactComponent };